import { useStaticQuery, graphql } from 'gatsby';


export const Photography = () => {
	const { wpgraphql } = useStaticQuery(
		graphql`
			query photographyPosts {
				wpgraphql {
					posts(first: 12, where: { categoryName: "photography" }) {
						nodes {
							title
							colourFeatureImage
							link
							featuredImage {
								sourceUrl
								srcSet
								mediaDetails {
									width
									height
								}
							}
							avVideoTeaser {
								avVideoTeaser {
									mediaItemUrl
								}
						  	}
						}
					}
				}
			}
		`
	);

	return wpgraphql.posts.nodes;
};

